import React, { useContext } from 'react';
import { IconButton, Box, useTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4'; // Dark mode icon
import Brightness7Icon from '@mui/icons-material/Brightness7'; // Light mode icon
import { ThemeContext } from '../App';

const ThemeToggle = ({ mobile = false }) => {
  const theme = useTheme();
  const { toggleColorMode, mode } = useContext(ThemeContext);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        ...(mobile
          ? {}
          : {
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              zIndex: 1000,
              backgroundColor: theme.palette.background.paper,
              boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
              p: 0.5,
            }),
      }}
    >
      <IconButton
        onClick={toggleColorMode}
        color={mobile ? 'inherit' : 'primary'}
        aria-label={
          mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
        }
      >
        {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Box>
  );
};

export default ThemeToggle;